import React, { useContext } from "react";
import { Switch, Route, useLocation } from "react-router-dom";
import Login from "./auth/Login";
import Report from "./report/Report";
import ProfileV2 from "./profile/ProfileV2";
import NotFound from "./utils/not_found";
import Header from "./header/Header";
import Footer from "./Footer/Footer";
import { GlobalState } from "../GlobalState";
import styled, { keyframes } from "styled-components";
import ReportsV2 from "./report/ReportsV2";
import DashboardEntryV3 from "./dashboardV3/DashboardEntryV3";
import WaterLevelPageV3 from "./dashboardV3/WaterLevelPageV3";
import PumpBorewellPageV3 from "./dashboardV3/PumpBorewellPageV3";
import SensePageV3 from "./dashboardV3/SensePageV3";
import ValvesPageV3 from "./dashboardV3/ValvesPageV3";
import SensorDetailV2 from "./sensor/SensorDetailV2";
import SolenoidDetailV2 from "./sensor/SolenoidDetailV2";
import MotorDetailV2 from "./sensor/MotorDetailV2";
import WeeklyMotorDetail from "./report/weeklyRunTimeDetail";
import SplashScreen from "./utils/SplashScreen";
import { DashboardReadyProvider, useDashboardReady } from "./utils/dashboardReady";

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const StyledFooter = styled(Footer)`
  margin-top: auto;
`;

const MainContent = styled.div`
  flex: 1;
  padding-top: 14px;
`;

const spin = keyframes`to { transform: rotate(360deg); }`;
const AuthLoading = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const AuthSpinner = styled.div`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 3px solid #E5E7EB;
  border-top-color: #237A35;
  animation: ${spin} 0.8s linear infinite;
`;

const FullscreenOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
`;
// Covers Header + content with the splash until DashboardEntryV3 is ready.
// Only active on "/" — other routes are unaffected.
function DashboardGate() {
  const { pathname } = useLocation();
  const { ready } = useDashboardReady();


  if (pathname !== "/" || ready) return null;
  return (
    <FullscreenOverlay>
      <SplashScreen />
    </FullscreenOverlay>
  );
}

export default function Pages() {
  const state = useContext(GlobalState);
  const [isLogged] = state.userAPI.isLogged;
  const [token] = state.token;

  if (!isLogged && token) {
    return (
      <AuthLoading>
        <AuthSpinner />
      </AuthLoading>
    );
  }

  if (isLogged) {
    return (
      <DashboardReadyProvider>
        <Container>
          <DashboardGate />
          <Header />
          <MainContent>
            <Switch>
              <Route path="/sensor/:sensor_id/:sensor_type" exact component={SensorDetailV2} />
              <Route path="/motor/:motor_id/sensor/:sensor_id/:sensor_type" exact component={MotorDetailV2} />
              <Route path="/profile" exact component={ProfileV2} />
              <Route path="/reports" exact component={ReportsV2} />
              <Route path="/hub" exact component={DashboardEntryV3} />
              <Route path="/water" exact component={WaterLevelPageV3} />
              <Route path="/pumps" exact component={PumpBorewellPageV3} />
              <Route path="/sense" exact component={SensePageV3} />
              <Route path="/valves" exact component={ValvesPageV3} />
              <Route path="/report" exact component={Report} />
              <Route path="/" exact component={DashboardEntryV3} />
              <Route path="/solenoid/:solenoid_id/:location_name" component={SolenoidDetailV2} />
              <Route path="/weekly-detail" exact component={WeeklyMotorDetail} />
              <Route path="*" exact component={NotFound} />
            </Switch>
          </MainContent>
          <StyledFooter />
        </Container>
      </DashboardReadyProvider>
    );
  }

  return (
    <Switch>
      <Route path="/" exact component={Login} />
      <Route path="*" component={NotFound} />
    </Switch>
  );
}